
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetSettingsProposal as ObiTargetSettingsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-settings-proposal.js';
 
 
 

 
 export const ObiTargetSettingsProposal = createComponent({
   react: React,
   tagName: 'obi-target-settings-proposal',
   elementClass: ObiTargetSettingsProposalElement,
   events: {
     
   }
  });
 
 